// pages/Roles.js
import React from 'react';
import RoleManager from '../components/RoleManager';

const Roles = () => {
  return (
    <div>
      <h1>Roles Management</h1>
      <RoleManager />
    </div>
  );
};

export default Roles;